import 'font-awesome/css/font-awesome.css'
import Vue from 'vue'
import App from './App'
import store from './config/store'
import router from './config/router'

import './config/bootstrap'
import './config/axios'
import './config/msgs'
import './config/mq'
import './config/mask'
import './config/vuelidate'
import './config/directive'
import './config/mixinform'

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')